import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { payrollProgress, payrollRun } from "../../api/payroll";

// ذاكرة لقطة خارج المكوّن: تُبقي آخر بيانات الرواتب فيظهر المربع/العدّاد فورًا وثابتًا عند العودة للصفحة
// (لا يُعاد تحميل المربع من جديد)، ثم نحدّث البيانات في الخلفية — والأنيميشن يبقى للأرقام فقط.
const SNAP = { key: "", run: null, progress: null };
const keyOf = (f) => `${f.month}|${f.branch_id}|${f.user_id}`;

export const usePayrollData = (filters) => {
  const { t } = useTranslation();
  const fresh = SNAP.key === keyOf(filters);
  const [run, setRun] = useState(fresh ? SNAP.run : null);
  const [progress, setProgress] = useState(fresh ? SNAP.progress : null);

  const load = useCallback(async () => {
    if (!filters.branch_id || !filters.user_id) { setRun(null); return; }
    const branch = filters.branch_id === "all" ? undefined : filters.branch_id;
    const person = filters.user_id === "all" ? undefined : filters.user_id;
    try {
      const r = await payrollRun(filters.month, branch, person);
      const p = await payrollProgress(filters.month, branch);
      setRun(r);
      setProgress(p);
      SNAP.key = keyOf(filters);
      SNAP.run = r;
      SNAP.progress = p;
    } catch {
      toast.error(t("errors.generic"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.month, filters.branch_id, filters.user_id]);

  useEffect(() => { load(); }, [load]);
  return { run, progress, load };
};
